import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const ViolationsTableColumnsModel: ITableColumn[] = [
  {
    labelPath: 'violationsPage.gridColumns.violationName',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.TextWithIconAndTooltip,
    width: 470,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'violationName',
    iconSrc: 'iconSrcViolationName',
    tooltipIconText: 'toolTipViolationName',
  },
  {
    labelPath: 'violationsPage.gridColumns.resourceName',
    propertyKey: 'resourceName',
    colType: TableColumnTypeEnum.Text,
    width: 280,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'resourceName',
    descriptionLabelPath: 'commonEntitiesInfo.resourceName',
  },
  {
    labelPath: 'violationsPage.gridColumns.owasp',
    propertyKey: 'owasp',
    colType: TableColumnTypeEnum.Text,
    width: 360,
    widthType: WidthType.Pixel,
    toCapitalize: true,
    isSortable: true,
    sortKey: 'owasp',
  },
  {
    labelPath: 'violationsPage.gridColumns.resourceType',
    propertyKey: 'resourceType',
    colType: TableColumnTypeEnum.Text,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'resourceType',
    descriptionLabelPath: 'commonEntitiesInfo.resourceType',
  },
  {
    labelPath: 'violationsPage.gridColumns.ruleTags',
    propertyKey: 'ruleTags',
    colType: TableColumnTypeEnum.Tag,
    width: 184,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'violationsPage.gridColumns.createdBy',
    propertyKey: 'createdBy',
    colType: TableColumnTypeEnum.TextOrNA,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'createdByName',
    tooltipDynamicText: 'notApplicableCreatedByTooltipText',
    descriptionLabelPath: 'commonEntitiesInfo.createdBy',
  },
  {
    labelPath: 'violationsPage.gridColumns.ownedBy',
    propertyKey: 'ownedBy',
    colType: TableColumnTypeEnum.MultiValueOrNA,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: false,
    tooltipDynamicText: 'notApplicableOwnedByTooltipText',
    descriptionLabelPath: 'commonEntitiesInfo.ownedBy',
  },
  {
    labelPath: 'violationsPage.gridColumns.severity',
    propertyKey: 'severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 126,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'severity',
  },
  {
    labelPath: 'violationsPage.gridColumns.labels',
    propertyKey: 'labels',
    colType: TableColumnTypeEnum.Label,
    width: 146,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'violationsPage.gridColumns.firstSeen',
    propertyKey: 'firstSeen',
    colType: TableColumnTypeEnum.Date,
    width: 110,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'firstSeen',
  },
  {
    labelPath: 'violationsPage.gridColumns.violationStatus',
    propertyKey: 'statusLabel',
    colType: TableColumnTypeEnum.StatusLabel,
    width: 140,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'status',
  },
  {
    labelPath: 'violationsPage.gridColumns.resourceStatus',
    propertyKey: 'resourceStatusLabel',
    colType: TableColumnTypeEnum.StatusLabel,
    isSortable: true,
    sortKey: 'resourceStatus',
    width: 144,
    widthType: WidthType.Pixel,
  },
];
